import { combineReducers } from 'redux';
import list from './assessmentsReducer';
import users from './usersReducer';
import sections from './sectionsReducer';
import currentAssessment from './currentAssessmentReducer';
import status from './statusReducer';
import bugReports from './bugReportsReducer';
import { LOGOUT } from '../actions/usersActionTypes';

const assessments = combineReducers({
  list,
  currentAssessment,
});

const appReducer = combineReducers({
  assessments,
  users,
  sections,
  status,
  bugReports,
});

const rootReducer = (state, action) => {
  const newState = action.type === LOGOUT ? undefined : state;
  return appReducer(newState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js